"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgLogIn04Alt = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M1.34 14.724c-.127-.499-.19-.748-.109-1.016.065-.214.246-.447.437-.563C1.908 13 2.203 13 2.795 13h10.79l-2.292 2.293a1 1 0 0 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414l-4-4a1 1 0 1 0-1.414 1.414L13.586 11H2.796c-.593 0-.889 0-1.128-.145a1.092 1.092 0 0 1-.437-.563c-.082-.268-.018-.517.109-1.016C2.552 4.518 6.865 1 12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11c-5.135 0-9.448-3.518-10.66-8.276Z", fill: "currentColor" }) }))); };
exports.default = SvgLogIn04Alt;
